import React from 'react';
import {Box} from '@mui/material';
import ExportApp from "./Functionality/ExportApp";
import CustomModal from "../../components/Modal/CustomModal";
import {CustomCheckbox} from "../../components/CustomCheckbox";
import CustomDescriptionLabel from "../../components/CustomDescriptionLabel";
const OptionModal = (props) => {
    const { onHide, excel, option, body, searchElement, moduleId, exportAttendance, search, contractorSupplier, setDisplayModal  } = props;
    const {
        t,
        checkboxes,
        selectedOptions,
        selectAll,
        handleDownloadExcelAttendance,
        handleDownloadExcel,
        handleDownloadPDFAttendance,
        handleDownloadPDF,
        handleSelectAllChange,
        handleCheckboxChange
    } = ExportApp({
        onHide, option, body, searchElement, moduleId, exportAttendance, search, contractorSupplier
    });

    return (
        <CustomModal
            {...props}
            title={"export_file"}
            size="lg"
            cancelButton={true}
            confirmButton={true}
            onConfirm={ excel
                ? exportAttendance
                    ? handleDownloadExcelAttendance
                    : handleDownloadExcel
                : exportAttendance
                    ? handleDownloadPDFAttendance
                    : handleDownloadPDF
            }
        >
            <div className={"row justify-content-center"}>
                <Box className={"col-12"}>
                    <CustomDescriptionLabel trans={t('instruction_headers')}/>
                </Box>
                <Box className={"col-12 d-flex justify-content-center align-self-stretch"}>
                    <CustomDescriptionLabel className={"font-color-general-950"} bold={'bold'} trans={t('instruction_subheader')}/>
                </Box>
                <Box className={"col-12 d-flex justify-content-center align-self-stretch"}>
                    <CustomDescriptionLabel trans={t('option') + ": " }/>
                    <CustomDescriptionLabel className={"font-color-general-950"} trans= {(excel ? t('excel') : t('pdf'))} bold={"bold"}/>
                </Box>
                <Box className={"col-12 d-flex justify-content-center align-self-stretch"}>
                    <CustomDescriptionLabel  trans={t('model') + ": " }/>
                    <CustomDescriptionLabel className={"font-color-general-950"} trans={t(option)} bold={"bold"}/>
                </Box>
                <Box className='col-12 mt-4'>
                    <CustomCheckbox id={"cb_om_select_all"}
                                    trans={"de_/_select_all"}
                                    name={"selectAll"}
                                    checked={selectAll}
                                    onChange={handleSelectAllChange}
                                    bold={"bold"}
                    />
                </Box>
                {checkboxes.map((checkbox) => (
                    <Box className='col-sm-12 col-md-4 col-xxl-4 col-lg-4'>
                        <CustomCheckbox id={checkbox.id}
                                        trans={checkbox.name}
                                        name={checkbox.name}
                                        checked={selectedOptions.includes(checkbox.name)}
                                        onChange={() => handleCheckboxChange(checkbox.id, checkbox.name)}
                        />
                    </Box>
                ))}
            </div>
        </CustomModal>
    );
};

export default OptionModal;
